import styled from "styled-components";

const ProgressBar = styled(
  ({
    className,
    progressItems,
    defaultValue,
    onSelect = () => {},
    enabled,
  }) => {
    const index = progressItems.findIndex(
      (item) => item.progress_name === defaultValue
    );
    const activeIndex = index >= 0 ? index : 0;

    return (
      <div className={className}>
        <div className="progress-items">
          {progressItems.map((item, itemIndex) => {
            return (
              <div
                key={item.progress_name ?? itemIndex}
                className="progress-item"
                onClick={() => enabled && onSelect(item)}
              >
                <div
                  className={
                    "progress-bar-segment" +
                    (itemIndex <= activeIndex ? " active" : "")
                  }
                />
                <div
                  className={
                    "progress-legend-item" +
                    (itemIndex <= activeIndex ? " active" : "")
                  }
                >
                  {item.progress_name}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
)`
  border-radius: 5px;
  & .progress-items {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(90px, 1fr));
    column-gap: 5px;
    row-gap: 20px;
  }
  & .progress-item {
    cursor: pointer;
    min-width: 0;
  }
  & .progress-bar-segment {
    width: 100%;
    height: 5px;
    border-radius: 5px;
    background-color: ${({ theme }) => theme.palette.divider};
    transition: background-color 0.2s ease;
  }
  & .progress-bar-segment.active {
    background-color: ${({ theme }) => theme.palette.primary.main};
  }
  & .progress-legend-item {
    margin-top: 5px;
    font-size: 10px;
    color: ${({ theme }) => theme.palette.text.secondary};
    height: 18px;
    min-width: 0;
    padding: 0 3px;
    border-left: 1px solid ${({ theme }) => theme.palette.divider};
    overflow: hidden;
    transition: font-size 0.1s ease, font-weight 0.1s ease;
    text-overflow: ellipsis;
    white-space: nowrap;
    &:hover {
      font-weight: bold;
      font-size: 12px;
    }
  }
  & .progress-legend-item.active {
    color: ${({ theme }) => theme.palette.text.primary};
    font-weight: bold;
    font-size: 12px;
  }
`;

export default ProgressBar;
